export default "<img src=\"{{url}}\" style=\"width: 101%\">"